import { render, staticRenderFns } from "./SortControl.vue?vue&type=template&id=3ae09b1a&scoped=true&"
import script from "./SortControl.vue?vue&type=script&lang=ts&"
export * from "./SortControl.vue?vue&type=script&lang=ts&"
import style0 from "./SortControl.vue?vue&type=style&index=0&id=3ae09b1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae09b1a",
  null
  
)

export default component.exports